import React from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import ButtonMkr from "../mkr/components/Button";

import {InfoCard} from "../components/InfoCard";
import {getPersistedState, LocalStorageKeys} from "../logic/Persistence";
import {Messaging} from "../Messaging";


const useLocalStyles = makeStyles(() => ({
  infoCard: {
    margin: '24px 0 2px 0',
    padding: '8px',
  },
}));

const dialogTitle = "You must Agree to the terms below before continuing";
const reviewTitle = "TERMS OF SERVICE";


export function ViewTerms() {
  const classes = useLocalStyles();
  // const [learnMore, setLearnMore] = React.useState(false);
  const termsAccepted = getPersistedState(LocalStorageKeys.accepted_terms, false);
  return (
    <Container maxWidth="md" style={{marginTop: 'auto', marginBottom: 'auto'}}>
      <InfoCard title={reviewTitle} className={classes.infoCard}>
        {Messaging.text.legalTerms}
        {/*{!learnMore && <ButtonMui size="small" color="primary" onClick={() => setLearnMore(true)}>*/}
        {/*  More information...*/}
        {/*</ButtonMui>}*/}
        {termsAccepted &&
        <Typography style={{textTransform: 'uppercase', marginTop: '1em', fontSize: '0.8rem'}}>
          Terms accepted
        </Typography>}
      </InfoCard>
      {/*{learnMore && <LearnMoreInfoCard embedded/>}*/}
    </Container>
  );
}

export function DialogTerms({onAccept}) {
  return (
    <Dialog open={true} aria-labelledby="Terms of Use" aria-describedby="Please accept the terms to continue">
      <DialogTitle style={{textTransform: 'uppercase'}}>{dialogTitle}</DialogTitle>
      <DialogContent>
        {Messaging.text.legalTerms}
      </DialogContent>
      <DialogActions>
        <ButtonMkr color="rose" onClick={() => onAccept()} style={{marginLeft: 'auto'}}>
          I Agree
        </ButtonMkr>
        <ButtonMkr href="https://www.google.com">
          Exit
        </ButtonMkr>
      </DialogActions>
    </Dialog>
  )
}
